import factory from './factory'

const schemas = {
  factory
}

export default schemas
